import qs from 'qs';

import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';

export const api = {
  cancelClaim: (
    url: string,
    invoiceNumber: string,
    claimId: number,
    serviceId?: number
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/claimStep2/cancelClaim`,
      {},
      {
        params: {
          invoicenumber: invoiceNumber,
          claimid: claimId,
          serviceid: serviceId,
        },
      }
    ),
  getData: (url: string, invoiceNumber: string, claimId: number, serviceId: number): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/claimStep2/getData`, {
      params: {
        invoicenumber: invoiceNumber,
        claimid: claimId,
        serviceid: serviceId,
      },
    }),
  saveClaimStep2: (
    url: string,
    invoiceNumber: string,
    claimId: number,
    serviceId: number,
    chargeCode?: Array<string>,
    reasonCode?: string | string[],
    serviceCode?: Array<string>,
    fuId?: string | string[]
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/claimStep2/saveClaimStep2`,
      {},
      {
        params: {
          invoicenumber: invoiceNumber,
          claimid: claimId,
          serviceid: serviceId,
          chargeCode: chargeCode,
          reasonCode: reasonCode,
          serviceCode: serviceCode,
          fuId: fuId,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
      }
    ),
};
